import { render, staticRenderFns } from "./operateList.vue?vue&type=template&id=52722134&scoped=true"
import script from "./operateList.vue?vue&type=script&lang=js"
export * from "./operateList.vue?vue&type=script&lang=js"
import style0 from "./operateList.vue?vue&type=style&index=0&id=52722134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52722134",
  null
  
)

export default component.exports